"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function validateName(value) {
    return value && /^[a-z ,.'-]+$/i.test(value)
        ? undefined
        : 'Invalid characters';
}
exports.default = validateName;
